import React from "react";
import { XCircle } from "lucide-react";

const PaymentFailed = () => {
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <XCircle size={70} color="#ef4444" />

        <h1 style={styles.title}>Payment Failed</h1>

        <p style={styles.subtitle}>
          Something went wrong while processing your payment.
          Please try again or contact support if the issue continues.
        </p>

        <div style={styles.buttons}>
          <button
            style={styles.retryBtn}
            onClick={() => window.history.back()}
          >
            Try Again
          </button>

          <button
            style={styles.homeBtn}
            onClick={() => (window.location.href = "/")}
          >
            Go to Home
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f5f7fb",
    fontFamily: "Arial, sans-serif"
  },

  card: {
    background: "#fff",
    padding: "50px",
    borderRadius: "14px",
    textAlign: "center",
    width: "420px",
    boxShadow: "0 10px 35px rgba(0,0,0,0.08)"
  },

  title: {
    fontSize: "28px",
    marginTop: "15px",
    marginBottom: "10px",
    fontWeight: "600"
  },

  subtitle: {
    color: "#6b7280",
    fontSize: "15px",
    lineHeight: "22px",
    marginBottom: "30px"
  },

  buttons: {
    display: "flex",
    gap: "15px",
    justifyContent: "center"
  },

  retryBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "none",
    background: "#ef4444",
    color: "#fff",
    fontWeight: "600",
    cursor: "pointer"
  },

  homeBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    background: "#fff",
    fontWeight: "600",
    cursor: "pointer"
  }
};

export default PaymentFailed;